import { render, staticRenderFns } from "./invitation.vue?vue&type=template&id=30acd75c&scoped=true&"
import script from "./invitation.vue?vue&type=script&lang=js&"
export * from "./invitation.vue?vue&type=script&lang=js&"
import style0 from "./invitation.vue?vue&type=style&index=0&id=30acd75c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30acd75c",
  null
  
)

export default component.exports